import React from 'react';

interface CustomButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  // Core functionality props
  children: React.ReactNode;
  isLoading?: boolean;

  // Customization props (optional, allowing user to override defaults)
  variant?: 'primary' | 'secondary' | 'danger' | 'custom'; // Predefined color schemes
  customColor?: string; // For the 'custom' variant

  // Additional props from your CSS
  showArrowOnHover?: boolean;
}

const CustomButton: React.FC<CustomButtonProps> = ({
  children,
  isLoading = false,
  variant = 'primary', // Default to primary blue theme
  customColor,
  showArrowOnHover = false,
  disabled, // Destructure native disabled prop
  className = '', // Allow external class merging
  ...rest // Capture remaining HTML button props (onClick, type, etc.)
}) => {
  const isDisabled = disabled || isLoading;

  // Conditionally build the class string
  const buttonClasses = [
    'proceed-button',
    variant,
    isDisabled ? 'disabled' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  // Optional: Dynamic background style if 'customColor' is provided
  // calculate a matching hover/active color.
  const style =
    variant === 'custom' && customColor ? { background: customColor } : {};

  return (
    <button
      className={buttonClasses}
      disabled={isDisabled}
      style={style}
      {...rest}
    >
      {isLoading ? (
        // Show Spinner if loading
        <div className="spinner" />
      ) : (
        <>
          {children}
          {/* Optionally show an arrow */}
          {showArrowOnHover && <span className="arrow">→</span>}
        </>
      )}
    </button>
  );
};

export default CustomButton;
